// externals
import { connect } from 'react-redux';

// selectors
import * as tradeInSelectors from '../../../store/mmd/tradeIn';
import * as tradeInComponentActionCreators from '../../../store/actionCreators';

// actions
import * as tradeInActionCreators from '../../../store/actionCreators';

// consts/enums
import * as tradeInRoutes from '../../../utils/routes';
import { processStepperRoutes } from '../../../utils/tradeInDecisionLogic';
import { LOAN_BALANCE_STEPS, STEPPER_ROUTES } from '../../../utils/constants';
import { isShowroomExperience } from '../../../utils/configUtils';

// components
import FindOpenLoanUI from './FindOpenLoanUI';

// interfaces/types
import { IFindOpenLoanUIStateProps, IFindOpenLoanUIDispatchProps } from './FindOpenLoanInterfaces';
import { IRootProps } from '../../../components/RootProps';
import { TRADEIN_ESTIMATE_METHODS } from '../constants';
import { StepperRoute } from '../../../types';

export const mapStateToProps = (state: any, ownProps: IRootProps): IFindOpenLoanUIStateProps => {
    const { tradeIn, tradeInState } = tradeInSelectors.getTradeInState(state, ownProps.tradeIndex);
    const isAmdLienPayoffQuoteSpOnSPEnabled = tradeInSelectors.isAmdLienPayoffQuoteEnabled(state);
    const vin = tradeIn?.vehicle?.vin || '';

    const pageTitle = 'Trade-In Vehicle';
    const pageSubTitle = 'Determine how much your current vehicle, is worth, and apply that value to your new vehicle.';

    const isFetchingLienholders = tradeInSelectors.getTradeInIsLienholdersLoading(tradeInState);
    const isFetchingLienholdersOptions = tradeInSelectors.getTradeInIsLienholdersOptionsLoading(tradeInState);
    const isPayoffQuoteInProgress = tradeInSelectors.getTradeInIsLienholdersPayoffQuoteOptionsLoading(tradeInState);

    const lienholdersData = tradeInSelectors.getTradeInLienholders(tradeInState);
    const lienholdersOptionsData = tradeInSelectors.getTradeInLienholdersOptions(tradeInState);
    const payoffQuoteData = tradeInSelectors.getTradeInLienholdersPayoffQuoteData(tradeInState);

    const isSalesView = isShowroomExperience(ownProps.config);
    const tradeInSource = tradeIn?.source;

    //based on tradeIn source decide the stepperRoutes
    const stepperRouteMap: Record<string, StepperRoute[]> = {
        [TRADEIN_ESTIMATE_METHODS.ico]: STEPPER_ROUTES.findOpenLoanForICO,
        [TRADEIN_ESTIMATE_METHODS.kbb]: STEPPER_ROUTES.findOpenLoanForEstimate,
        [TRADEIN_ESTIMATE_METHODS.SD]: STEPPER_ROUTES.findOpenLoanForEstimate,
        [TRADEIN_ESTIMATE_METHODS.USER]: STEPPER_ROUTES.findOpenLoanForAppraisal
    };

    const selectedStepperRoute: StepperRoute[] = stepperRouteMap[tradeInSource] || STEPPER_ROUTES.loanBalance;

    const stepperRoutes = processStepperRoutes(
        state,
        selectedStepperRoute,
        isSalesView,
        isAmdLienPayoffQuoteSpOnSPEnabled,
        ownProps.tradeIndex
    );

    return {
        pageTitle,
        pageSubTitle,
        stepperRoutes,
        isFetchingLienholders,
        isFetchingLienholdersOptions,
        lienholdersData,
        lienholdersOptionsData,
        payoffQuoteData,
        isPayoffQuoteInProgress,
        vin,
        urlPath: ownProps.tradeInRoute
    };
};

export const mapDispatchToProps = (dispatch: any): IFindOpenLoanUIDispatchProps => {
    const CURRENT_TRADE_IN_STEP = 'Loan Balance';

    return {
        dispatchAnalytics: (type: string, description: string) => {
            dispatch(tradeInActionCreators.dispatchAnalytics(type, description));
        },
        goToRoute: (route: string) => {
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(route));
        },
        fetchLienholders: () => {
            dispatch(tradeInActionCreators.fetchTradeInLienholders());
        },
        fetchLienholdersOptions: (partnerId: string) => {
            dispatch(tradeInActionCreators.fetchTradeInLienholdersOptions(partnerId));
        },
        postPayoffQuote: (queryParams: string) => {
            dispatch(tradeInActionCreators.postTradeInPayoffQuote(queryParams));
        },
        clearPayoffQuoteData: () => {
            dispatch(tradeInActionCreators.clearPayoffQuoteData());
        },
        onEstimateBalanceClick: () => {
            dispatch(tradeInActionCreators.cdlEstimateBalanceLinkClicked(LOAN_BALANCE_STEPS.FIND_OPEN_AUTO_LOAN));
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_ESTIMATE_LOAN_BALANCE));
        },
        goBack: () => {
            dispatch(tradeInActionCreators.cdlBackButtonClicked(CURRENT_TRADE_IN_STEP));
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_REGISTRATION_DETAILS));
        },
        removeTradeIn: () => {
            dispatch(tradeInActionCreators.cdlCancelTradeInButtonClicked(CURRENT_TRADE_IN_STEP));
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_IN));
            dispatch(tradeInActionCreators.removeTradeIn());
        },
        saveAmountOwed: (amountOwed) => {
            dispatch(tradeInActionCreators.updateTradeInBalanceOwed(amountOwed));
        },
        saveAmountOwedSource: (amountOwedSource) => {
            dispatch(tradeInActionCreators.updateTradeInLenderName(amountOwedSource));
        },
        cdlContinueButtonClicked: () => {
            dispatch(tradeInComponentActionCreators.cdlFindOpenLoanContinueButtonClicked());
        },
        cdlTradeInProgressStepperClicked: (analyticsId: string) => {
            dispatch(tradeInComponentActionCreators.cdlTradeInProgressStepperClicked(analyticsId));
        }
    };
};

const FindOpenLoan = connect(mapStateToProps, mapDispatchToProps)(FindOpenLoanUI);

export default FindOpenLoan;
